module.exports = __webpack_public_path__ + "fonts/Ubuntu-Medium.5369c0a.eot";